import React, { useState, useEffect } from "react";
import "../Home/Homeold.css";
import { FaEnvelope } from "react-icons/fa";
import banner1 from "../../assets/images/banner1.jpg";
import banner2 from "../../assets/images/banner2.jpg";
import banner3 from "../../assets/images/banner3.jpg";
import profilebg from "../../assets/images/profile-back.jpg";
import appstore from "../../assets/images/app-store.jpg";
import appstoreapple from "../../assets/images/app-store-apple.png";
import appstoreplay from "../../assets/images/app-store-play.png";
import about from "../../assets/images/about-img.jpg";
import serchuser1 from "../../assets/images/serchuser1.png";
import serchuser2 from "../../assets/images/serchuser2.png";
import serchuser3 from "../../assets/images/serchuser3.png";
import Footer from "../Footer/Footer";
import { subscribeTonewsletter } from "../api/api";
import Swal from "sweetalert2";
import { Navigate, useNavigate } from "react-router-dom";
import { miscHome } from "../api/api";
import { environment } from "../../environments/environments";
import { FaArrowRight, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
const newsletterSchema = Yup.object({
  email: Yup.string()
    .email("Please enter a valid email")
    .required("Email is required"),
});

const servicesArray = [
  {
    title: "Privacy-First Approach",
    description:
      "Your journey is personal. We keep it that way with manual profile vetting and a secure, private platform. No noise. No pressure.",
  },
  {
    title: "Compatibility You Can Trust",
    description:
      "We go beyond attraction. Our match system is rooted in temperament theory, value alignment, and life goals to ensure deep, lasting connections.",
  },
  {
    title: "Cultural Sensitivity Matters",
    description:
      "Love shouldn't come at the cost of your values. We respect and factor in your cultural background, faith, and personal preferences because meaningful connections thrive on mutual respect and shared understanding.",
  },
  {
    title: "Admin-Controlled Selection",
    description:
      "Not every match makes the cut. Our team personally reviews and approves all matches, ensuring only serious, compatible connections get through. This means zero bots, no random swipes, and no time-wasters.",
  },
  {
    title: "Marriage Is the Goal",
    description:
      "This isn’t another dating app. Every step here is designed to help you connect deeply, date intentionally, and commit confidently.",
  },
];

const Homeoldpage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [email, setemail] = useState("");
  const [bulletIndex, setBulletIndex] = useState(0);
  const [isDesignMode, setIsDesignMode] = useState(true);
  const [storedata, setstoredata] = useState({});
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slideInterval, setSlideInterval] = useState(null);
  const slides = [
    {
      id: 1,
      title: "Serious About Love,",
      highlighted: "Commitment & Vow? So Are We.",
      image: banner3,
      btnLink: "/login",
      btnText: "Find A Match",
    },
    {
      id: 2,
      title: "Love That Starts With Clarity.",
      highlighted: "Grows With Purpose.",
      image: banner2,
      btnLink: "/login",
      btnText: "Find A Match",
    },
    {
      id: 3,
      title: "Matchmaking Is Not An",
      highlighted: "Ancient Word!",
      image: banner1,
      btnLink: "/login",
      btnText: "Find A Match",
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 3000);
    setSlideInterval(interval);

    return () => clearInterval(interval);
  }, []);

  const handleMouseEnter = () => {
    clearInterval(slideInterval);
  };

  const handleMouseLeave = () => {
    const interval = setInterval(nextSlide, 3000);
    setSlideInterval(interval);
  };

  useEffect(() => {
    const getdata = async () => {
      const miscHomedata = await miscHome();
      console.log("miscHomeData", JSON.stringify(miscHomedata?.banner));
      setstoredata(miscHomedata);
    };
    getdata();
  }, []);
  const navigate = useNavigate();
  useEffect(() => {
    let interval;
    let timeout;

    if (currentIndex === 2) {
      interval = setInterval(() => {
        setBulletIndex((prev) => (prev + 1) % 3);
      }, 5000);
      timeout = setTimeout(() => {
        setCurrentIndex(0);
      }, 8000);
    } else {
      timeout = setTimeout(() => {
        if (storedata?.banner?.length) {
          setCurrentIndex(
            (prevIndex) => (prevIndex + 1) % storedata.banner.length
          );
        }
      }, 6000);
    }

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
      setBulletIndex(0);
    };
  }, [currentIndex, storedata?.banner?.length]);

  const goToImage = (index) => {
    setCurrentIndex(index);
  };
  useEffect(() => {
    console.log("Current index is:", currentIndex);
  }, [currentIndex]);
  return (
    <>
      <div
        className="slider-container"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="slider">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`slide ${index === currentSlide ? "active" : ""}`}
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${slide.image})`,
              }}
            >
              <div className="containerall">
                <div className="slide-content">
                  <h2>
                    {slide.title.split(slide.highlighted)[0]}
                    <span> {slide.highlighted}</span>
                  </h2>
                  <a href={slide.btnLink} className="slider-btn">
                    {slide.btnText}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="slider-arrow left" onClick={prevSlide}>
          <FaChevronLeft />
        </div>
        <div className="slider-arrow right" onClick={nextSlide}>
          <FaChevronRight />
        </div>
      </div>
      <div className="about">
        <div className="containerall">
          <div className="aboutus">
            <div className="about-img">
              <img src={about} alt="Dynamic" />
            </div>
            <div className="about-text">
              <h5>About Us</h5>
              <h2>
                Start Your Search
                <br />
                for Love
              </h2>
              <p>
                At ConnectToVow, we believe love is sacred, marriage is
                intentional, and finding the right person shouldn't feel like a
                gamble. We are a compatibility-driven matchmaking platform built
                for people who are serious about love and committed to building
                meaningful, lifelong relationships.
              </p>
              <p>
                Modern dating apps, instant matches, superficial talks, and
                constant swiping without any real direction can be frustrating,
                and we get that. We have therefore established a setting that
                values cultural sensitivity, depth, and trust.
              </p>
              <button className="main-btn" onClick={() => navigate("/about")}>
                Read More
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="searchlove">
        <div className="containerall">
          <div className="home-thirdContainer">
            <div className="home-card">
              <div className="home-profilePic">
                <img src={serchuser1} alt="profile" />
              </div>
              <div className="home-descriptiondiv">
                <h4 className="home-title">Serious About Love?</h4>
                <p className="home-description-first">
                  'We're not here for flings or endless swiping. ConnectToVow is
                  for people who are done playing games and ready to build
                  something real. Every feature is designed to help you connect
                  with someone who shares your desire for lasting love and
                  lifelong commitment'
                </p>
                <div className="bottom-circle-arrow">
                  <div className="home-bottomCircle">
                    <FaChevronRight size="md" />
                  </div>
                </div>
              </div>
            </div>
            <div className="home-card">
              <div className="home-profilePic">
                <img src={serchuser2} alt="profile" />
              </div>
              <div className="home-descriptiondiv">
                <h4 className="home-title">Trustable by Design!</h4>
                <p className="home-description-first">
                  You can count on our process. With admin-controlled matching,
                  manual profile verification, and a privacy-first platform,
                  you’re in a space that protects your journey and prioritizes
                  authenticity. No bots. No randomness. Just real people with
                  real intentions.
                </p>
                <div className="bottom-circle-arrow">
                  <div className="home-bottomCircle">
                    <FaChevronRight size="md" />
                  </div>
                </div>
              </div>
            </div>
            <div className="home-card">
              <div className="home-profilePic">
                <img src={serchuser3} alt="profile" />
              </div>
              <div className="home-descriptiondiv">
                <h4 className="home-title">Built for You</h4>
                <p className="home-description-first">
                  Your values, your culture, your pace, we see you. From
                  temperament-based compatibility to culturally sensitive
                  matchmaking, we’ve created a platform that reflects what
                  matters to you. This isn’t one-size-fits-all love. This is
                  love that fits you.
                </p>
                <div className="bottom-circle-arrow">
                  <div className="home-bottomCircle">
                    <FaChevronRight size="md" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="home-sixdiv"
        style={{
          backgroundImage: `url(${profilebg})`,
        }}
      >
        <div className="containerall">
          <div className="home-sixdivoverlay">
            <h2 className="home-hero-text">
              Real People.
              <br /> Real Intentions. Real Love.
            </h2>
            <h4 className="home-hero-text2">
              One match at a time. Sign up to bliss
            </h4>
            <button className="main-btn" onClick={() => navigate("/login")}>
              Create Your Profile
            </button>
          </div>
        </div>
      </div>
      <div className="service-firstContainer-div">
        <div className="containerall">
          <div className="services-title-div">
            <h2 className="services-title">Why Choose Us</h2>
          </div>
          <div className="services-grid">
            {servicesArray?.map((service, index) => (
              <div key={index} className="service-item">
                <div className="service-icon">
                  <FaArrowRight size="md" />
                </div>
                <h3 className="service-title">{service?.title}</h3>
                <div className="service-description-div">
                  <p className="service-description">{service?.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        className="home-sixdiv"
        style={{
          backgroundImage: `url(${appstore})`,
        }}
      >
        <div className="containerall">
          <div className="home-sixdivoverlay">
            <p className="home-app-contant">People joined already!</p>
            <h2 className="home-app-text">Download the App Now</h2>
            <h4 className="home-app-text2">
              Unlock amazing features and convenience -Download the app now!
              Stay connected on the go and enjoy a seamless experience.
            </h4>
            <div className="app-store-main">
              <a
                href="https://apps.apple.com/us/app/connecttovow/id6744053816"
                target="_blank"
                rel="noopener noreferrer"
                className="app-store-sec"
              >
                <img src={appstoreapple} alt="App Store Apple" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.connecttovow"
                target="_blank"
                rel="noopener noreferrer"
                className="app-store-sec"
              >
                <img src={appstoreplay} alt="App Store Play" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="home-sevendiv">
        <div className="containerall">
          <div className="home-newsletter-container">
            <div className="home-newsletter-content">
              <div className="home-newsletter-title-div">
                <FaEnvelope style={{ fontSize: "80px", color: "#fff" }} />
                <h2 className="home-newsletter-title">
                  Join our community where love leads to vows.
                </h2>
              </div>
              <p className="home-newsletter-description">
                Begin your journey to forever...
                <br />
                Start your journey to “I do” today.
              </p>
              <button className="main-btn" onClick={() => navigate("/login")}>
                Create Your Profile
              </button>
            </div>

            <div className="home-newsletter-form">
              <div className="home-newsletter-title-div">
                <h2 className="home-newsletter-title-sub">
                  Subscribe to Our Newsletter
                </h2>
              </div>

              <Formik
                initialValues={{ email: "" }}
                validationSchema={newsletterSchema}
                onSubmit={async (values, { resetForm, setSubmitting }) => {
                  try {
                    const response = await subscribeTonewsletter(values);
                    if (response?.success) {
                      Swal.fire({
                        icon: "success",
                        title: "Subscribed!",
                        text: response?.message,
                      });
                      resetForm();
                    } else {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: response?.message,
                      });
                    }
                  } catch (err) {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text:
                        err?.response?.data?.message ||
                        err.message ||
                        "Something went wrong!",
                    });
                  } finally {
                    setSubmitting(false);
                  }
                }}
                validate={(values) => {
                  try {
                    newsletterSchema.validateSync(values, {
                      abortEarly: false,
                    });
                  } catch (validationErrors) {
                    const firstError = validationErrors.errors[0];
                    Swal.fire({
                      icon: "error",
                      title: "Validation Error",
                      text: firstError,
                    });
                    return { email: firstError };
                  }
                }}
              >
                {({ isSubmitting }) => (
                  <Form className="inputbtn">
                    <Field
                      name="email"
                      type="email"
                      placeholder="YOUR EMAIL ADDRESS"
                      className="home-email-input"
                    />
                    <button
                      type="submit"
                      className="main-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Subscribe"}
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      {/* <div>
        <Footer />
      </div> */}
    </>
  );
};
export default Homeoldpage;
